let fields = [];
fields.push({ size: "1/2", type: "input", attribute: "cif", validation: "required" });
fields.push({ size: "1/2", type: "input", attribute: "alias", validation: "required" });

export default fields;